module.exports = __webpack_public_path__ + "static/media/notification_netwell.9843eb18.svg";